import http from '../httpConfig';
import { API_ENDPOINTS } from '../utils/apiConstant';
import { AddEditApi } from '../interfaces/product.interface';
import queryString from 'query-string';

const list = (payload: any) => {
  const { searchText, ...rest } = payload;
  const params: any = { ...rest };
  if (searchText) params.search = searchText;
  return http.get(`${API_ENDPOINTS.listProducts}?${queryString.stringify(params)}`);
};

const add = (payload: AddEditApi) => {
  return http.post(API_ENDPOINTS.addProduct, payload);
};

const edit = (id: string, payload: AddEditApi) => {
  return http.put(`${API_ENDPOINTS.editProduct}/${id}`, payload);
};

const get = (id: string) => {
  return http.get(`${API_ENDPOINTS.getProduct}/${id}`);
};

const suggestions = (payload: { name: string }) => {
  return http.get(`${API_ENDPOINTS.suggestionsProducts}?name=${encodeURIComponent(payload.name)}&page=1&per_page=999`);
};

const lookup = (payload: { searchText?: string; divisionId?: string | number }) => {
  const params: any = {};
  if (payload.searchText) params.search = payload.searchText;
  if (payload.divisionId) params.division_id = payload.divisionId;
  return http.get(`${API_ENDPOINTS.lookupProducts}?${queryString.stringify(params)}`);
};

const ProductService = {
  list,
  add,
  edit,
  get,
  lookup,
  suggestions,
};

export default ProductService;
